Object.defineProperty(exports,"__esModule",{value:true});var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[typeof Symbol==='function'?Symbol.iterator:'@@iterator'](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if((typeof Symbol==='function'?Symbol.iterator:'@@iterator')in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}

if(typeof fetch==='undefined'){
var _fetch=require('whatwg-fetch');
}

var attachmentTypes=exports.attachmentTypes={
IMAGE:'image',
PPT:'ppt',
UNKNOWN:'unknown',
XLS:'xls',
DOC:'doc',
PDF:'pdf',
CSV:'csv',
SVG:'svg'};


var mediaProviders=exports.mediaProviders={
WIX_MEDIA:'WixMedia'};


var microsoftSubtypes=[
'vnd.ms-powerpoint',
'vnd.openxmlformats-officedocument.presentationml',
'vnd.ms-excel',
'vnd.openxmlformats-officedocument.spreadsheetml',
'vnd.ms-word',
'vnd.openxmlformats-officedocument.wordprocessingml'];


var stripMicrosoftSubtype=function stripMicrosoftSubtype(originalMime){var _originalMime$split=
originalMime.split('/'),_originalMime$split2=_slicedToArray(_originalMime$split,2),mimeType=_originalMime$split2[0],mimeSubtype=_originalMime$split2[1];
var microsoftSubtypeRegex=new RegExp(microsoftSubtypes.map(function(subtype){return subtype.replace('.','\\.');}).join('|'));
var res=microsoftSubtypeRegex.exec(mimeSubtype);
return res?mimeType+'/'+res:originalMime;
};

var stripImageSubtype=function stripImageSubtype(originalMime){var _originalMime$split3=
originalMime.split('/'),_originalMime$split4=_slicedToArray(_originalMime$split3,2),mimeType=_originalMime$split4[0],mimeSubtype=_originalMime$split4[1];
return mimeSubtype==='svg+xml'||mimeType!=='image'?originalMime:'image';
};

var stripSubtype=function stripSubtype(originalMime){
var stripedMicrosoftType=stripMicrosoftSubtype(originalMime);
return stripImageSubtype(stripedMicrosoftType);
};

var getAttachmentType=exports.getAttachmentType=function getAttachmentType(contentType){
switch(stripSubtype(contentType)){
case'text/csv':
return attachmentTypes.CSV;
case'image':
return attachmentTypes.IMAGE;
case'image/svg+xml':
return attachmentTypes.SVG;
case'application/msword':
case'application/vnd.ms-word':
case'application/vnd.openxmlformats-officedocument.wordprocessingml':
return attachmentTypes.DOC;
case'application/excel':
case'application/vnd.ms-excel':
case'application/vnd.openxmlformats-officedocument.spreadsheetml':
return attachmentTypes.XLS;
case'application/pdf':
return attachmentTypes.PDF;
case'application/vnd.ms-powerpoint':
case'application/vnd.openxmlformats-officedocument.presentationml':
return attachmentTypes.PPT;
default:
return attachmentTypes.UNKNOWN;}

};

var updateQueryStringParameter=function updateQueryStringParameter(uri,key,value){
key=encodeURIComponent(key);
value=encodeURIComponent(value);

var re=new RegExp('([?&])'+key+'=.*?(&|$)','i');
var separator=uri.indexOf('?')!==-1?'&':'?';
if(uri.match(re)){
return uri.replace(re,'$1'+key+'='+value+'$2');
}
return''+uri+separator+key+'='+value;
};

var getAttachmentDownloadUrl=exports.getAttachmentDownloadUrl=function getAttachmentDownloadUrl(_ref){var filename=_ref.filename,url=_ref.url;
var cloudPlatformAttachmentParam='response-content-disposition';
var cloudPlatformAttachmentParamValue='attachment;filename="'+filename+'"';
return updateQueryStringParameter(url,cloudPlatformAttachmentParam,cloudPlatformAttachmentParamValue);
};

var getAttachmentDownloadUrlFromGoogle=function getAttachmentDownloadUrlFromGoogle(_ref2){var filename=_ref2.filename,url=_ref2.url;
return{url:getAttachmentDownloadUrl({filename:filename,url:url})};
};

var getAttachmentDownloadUrlFromWixMedia=function getAttachmentDownloadUrlFromWixMedia(_ref3){var _ref3$baseUrl=_ref3.baseUrl,baseUrl=_ref3$baseUrl===undefined?'/':_ref3$baseUrl,url=_ref3.url,width=_ref3.width,height=_ref3.height,instance=_ref3.instance;
var fetchUrl=baseUrl+'_api/crm-inbox-server/attachment/'+url;
if(width&&height){
fetchUrl+='?height='+height+'&width='+width;
}
return fetch(fetchUrl,{
method:'GET',
headers:_defineProperty({},'X-Wix-Inbox-Instance',
instance)}).


then(function(res){
if(!res.ok){
throw'Error '+res.status;
}
return res;
}).
then(function(res){return res.json();}).
then(function(res){
var prefix='https://files.wix.com';
return Object.keys(res).reduce(function(acc,key){return(
_extends({},acc,_defineProperty({},key,''+prefix+res[key])));},{});
});
};

var getAttachmentUrl=exports.getAttachmentUrl=function getAttachmentUrl(_ref4){var baseUrl=_ref4.baseUrl,filename=_ref4.filename,url=_ref4.url,mediaProvider=_ref4.mediaProvider,instance=_ref4.instance,width=_ref4.width,height=_ref4.height;
if(mediaProvider===mediaProviders.WIX_MEDIA){
return getAttachmentDownloadUrlFromWixMedia({baseUrl:baseUrl,url:url,width:width,height:height,instance:instance});
}else{
return Promise.resolve(getAttachmentDownloadUrlFromGoogle({filename:filename,url:url}));
}
};


//////////////////
// WEBPACK FOOTER
// ../~/inbox-common/dist/attachments.js
// module id = 285
// module chunks = 0